import React from 'react';
import NavigationBrand from './NavigationBrand';
import ProfileUser from './ProfileUser';
import Menus from '../../../Menus';
import { SidebarProps } from '.';
import useLocalStorage from '../../../../../hooks/useUserData';

const Sidebar: React.FC<SidebarProps> = ({ menuList, user, theme }) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const profile = JSON.parse(userData?.auth);

  const listKhusus = {
    name: 'Team Learning',
    url: '#',
    icon: 'nav-icon side-bar-editor icn-svg',
    children: [
      {
        name: 'Executive Dashboard',
        icon: '',
        url: '/management/dashboard-executive',
        isMandatoryMenu: null,
        menuCode: null,
        children: null
      }
    ]
  };

  const allowedJobBands = [
    'Supervisor',
    'Associate Manager',
    'Manager',
    'Senior Manager',
    'General Manager',
    'Associate Director',
    'Executive Director',
    'DIRECTOR',
    'Managing Director'
  ].map((jobBand) => jobBand.toLowerCase());

  const jobBands = profile?.userData?.jobBand?.split(',') || [];

  const isAllowedJobBand = jobBands.some((jobBand) =>
    allowedJobBands.includes(jobBand.trim().toLowerCase())
  );

  if (isAllowedJobBand) {
    const teamLearningIndex = menuList.findIndex(
      (item) => item.name === 'Team Learning'
    );

    if (teamLearningIndex !== -1) {
      const hasDashboard = menuList[teamLearningIndex].children.some(
        (item) =>
          item.name === 'Executive Dashboard' ||
          item.name === 'Dashboard Executive'
      );

      if (!hasDashboard) {
        menuList[teamLearningIndex].children.push(listKhusus.children[0]);
      }
    } else {
      menuList.push(listKhusus);
    }
  }

  return (
    <aside
      className="b-sidebar"
      style={
        theme
          ? {
              backgroundColor: theme.colors.backgroundNavigation,
              borderRight: `1px solid ${
                theme.type === 'dark' ? theme.colors.border : '#dee2e6'
              }`
            }
          : {}
      }
    >
      <NavigationBrand user={user} theme={theme} />
      <div>
        <ProfileUser user={user} />
        <Menus menuList={menuList} />
      </div>
    </aside>
  );
};

export default Sidebar;
